import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Star, Check, X, MapPin } from "lucide-react";
import { api, V1 } from "@/lib/api";
import { toast } from "sonner";

export default function AdminReviews() {
  const [items, setItems] = useState([]);
  const load = () => api.get(`${V1}/reviews/pending`).then((r) => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const act = async (id, action) => {
    try {
      await api.patch(`${V1}/reviews/${id}`, { action });
      toast.success(action === "approve" ? "Onaylandı" : "Reddedildi");
      load();
    } catch { toast.error("İşlem başarısız"); }
  };

  return (
    <div className="space-y-6" data-testid="admin-reviews-page">
      <div>
        <div className="overline text-accent">Moderasyon</div>
        <h1 className="font-display text-3xl font-bold">Bekleyen Okul Yorumları</h1>
        <p className="text-muted-foreground mt-1">Onaylanan yorumlar okul detay sayfalarında görünür.</p>
      </div>
      <div className="grid gap-4">
        {items.length === 0 && <div className="p-10 rounded-xl border border-dashed border-border text-center text-muted-foreground">Bekleyen yorum yok.</div>}
        {items.map((r) => (
          <div key={r.id} className="p-6 rounded-xl border border-border bg-card" data-testid={`review-pending-${r.id}`}>
            <div className="flex flex-wrap justify-between gap-3">
              <div>
                {r.school && <div className="text-xs text-muted-foreground flex items-center gap-1"><MapPin className="h-3 w-3" /> {r.school.name} · {r.school.province}/{r.school.district}</div>}
                <div className="flex items-center gap-2 mt-1">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star key={i} className={`h-4 w-4 ${i < r.rating ? "fill-accent text-accent" : "text-muted-foreground"}`} />
                  ))}
                  {r.verified && <span className="text-[10px] uppercase tracking-widest text-success bg-success/10 px-2 py-0.5 rounded">Doğrulanmış</span>}
                </div>
                <div className="font-display font-bold text-lg mt-2">{r.title}</div>
                <div className="text-sm mt-1">{r.body}</div>
                <div className="text-xs text-muted-foreground mt-2">— {r.author_name} · {r.role} · {new Date(r.created_at).toLocaleDateString("tr-TR")}</div>
              </div>
              <div className="flex flex-col gap-2 min-w-[120px]">
                <Button size="sm" onClick={() => act(r.id, "approve")} data-testid={`approve-${r.id}`}><Check className="h-3 w-3" /> Onayla</Button>
                <Button size="sm" variant="outline" onClick={() => act(r.id, "reject")} data-testid={`reject-${r.id}`}><X className="h-3 w-3" /> Reddet</Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
